import {authenticationService} from "../AuthenticationService";
import axios from "axios";
import Config from "../../config/Config";

const adminApi = {
    uploadProfilePng: async (filesList) => {
        let formData = new FormData()
        formData.append("uploadedClinicPic", filesList.file);
        if (!authenticationService.currentUserValue)
            return;
        let SystemAdmin = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'multipart/form-data;Boundary=---WebKitFormBoundary7MA4YWxkTrZu0gW',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/sadeAdmins/${SystemAdmin.profile.UserStorageID}/clinic/${filesList.Clinic_ID}/uploadProfilePng`,
            formData,
            requestconfig
        );
    },

    generateLeumitReport: async (startDate,endDate) => {

        if (!authenticationService.currentUserValue)
            return;
        let SystemAdmin = authenticationService.currentUserValue;

        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/sadeAdmins/${SystemAdmin.profile.UserStorageID}/generateLeumitReport`,
            {startDate:startDate,endDate:endDate},
            requestconfig
        );
    },
    generateRequestHistory: async (requestID) => {

        if (!authenticationService.currentUserValue)
            return;
        let SystemAdmin = authenticationService.currentUserValue;

        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/sadeAdmins/${SystemAdmin.profile.UserStorageID}/generateRequestHistory`,
            {RequestID:requestID},
            requestconfig
        );
    },

    generateRequestsReport: async (startDate,endDate) => {

        if (!authenticationService.currentUserValue)
            return;
        let SystemAdmin = authenticationService.currentUserValue;

        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };

        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/sadeAdmins/${SystemAdmin.profile.UserStorageID}/generateRequestsReport`,
            {startDate:startDate,endDate:endDate},
            requestconfig
        );
    },


    addMediatorData: async (body) => {
        if (!authenticationService.currentUserValue)
            return;
        let SystemAdmin = authenticationService.currentUserValue;

        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return (await axios.post(
            `${Config.globalUrl}/api/v1/webapp/sadeAdmins/${SystemAdmin.profile.UserStorageID}/mediator/signup`,
            body,
            requestconfig
        ));
    },

    deleteMediatorData: async (mediator) => {
        if (!authenticationService.currentUserValue)
            return;
        let SystemAdmin = authenticationService.currentUserValue;

        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return (await axios.delete(
            `${Config.globalUrl}/api/v1/webapp/sadeAdmins/${SystemAdmin.profile.UserStorageID}/mediator/${mediator}/delete`,
            requestconfig
        ));
    },

    lockMediator: async (mediator) => {
        if (!authenticationService.currentUserValue)
            return;
        let SystemAdmin = authenticationService.currentUserValue;

        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return (await axios.get(
            `${Config.globalUrl}/api/v1/webapp/sadeAdmins/${SystemAdmin.profile.UserStorageID}/mediator/${mediator}/lock`,
            requestconfig
        ));
    },

    setMediatorData: async (body) => {
        if (!authenticationService.currentUserValue)
            return;
        let SystemAdmin = authenticationService.currentUserValue;

        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return (await axios.post(
            `${Config.globalUrl}/api/v1/webapp/sadeAdmins/${SystemAdmin.profile.UserStorageID}/mediator/update`,
            body,
            requestconfig
        ));
    },
    getAllMediators: async () => {
        if (!authenticationService.currentUserValue)
            return;
        let SystemAdmin = authenticationService.currentUserValue;

        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/sadeAdmins/${SystemAdmin.profile.UserStorageID}/mediators/getAllMediators`,
            requestconfig
        );
    },
    AddNewClinic: async (clinic) => {
        if (!authenticationService.currentUserValue)
            return;
        let SystemAdmin = authenticationService.currentUserValue;

        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return (await axios.post(
            `${Config.globalUrl}/api/v1/webapp/sadeAdmins/${SystemAdmin.profile.UserStorageID}/clinic/signup`,
            clinic,
            requestconfig
        ));
    },
    getClinicID: async () => {
        if (!authenticationService.currentUserValue)
            return;
        let SystemAdmin = authenticationService.currentUserValue;

        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return (await axios.post(
            `${Config.globalUrl}/api/v1/webapp/sadeAdmins/${SystemAdmin.profile.UserStorageID}/getClinicID`,
            {},
            requestconfig
        ));
    },
    EditClinic: async (clinic_data,Clinic_ID) => {
        if (!authenticationService.currentUserValue)
            return;
        let SystemAdmin = authenticationService.currentUserValue;

        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return (await axios.post(
            `${Config.globalUrl}/api/v1/webapp/sadeAdmins/${SystemAdmin.profile.UserStorageID}/clinics/${Clinic_ID}/profile`,
            clinic_data,
            requestconfig
        ));
    },
    getAllClinics: async () => {
        if (!authenticationService.currentUserValue)
            return;
        let SystemAdmin = authenticationService.currentUserValue;

            let requestconfig = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': authenticationService.currentUserValue.token,
                },
            };
            return await axios.get(
                `${Config.globalUrl}/api/v1/webapp/sadeAdmins/${SystemAdmin.profile.UserStorageID}/clinics/getAllClinics`,
                requestconfig
            );
    },
    AddNewHCP: async (hcp) => {
        if (!authenticationService.currentUserValue)
            return;
        let SystemAdmin = authenticationService.currentUserValue;

            let requestconfig = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': authenticationService.currentUserValue.token,
                },
            };
            return (await axios.post(
                `${Config.globalUrl}/api/v1/webapp/sadeAdmins/${SystemAdmin.profile.UserStorageID}/doctors/signup`,
                hcp,
                requestconfig
            ));
    },
    EditHCP: async (hcp_data,HCP_UserStorageID) => {
        if (!authenticationService.currentUserValue)
            return;
        let SystemAdmin = authenticationService.currentUserValue;

            let requestconfig = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': authenticationService.currentUserValue.token,
                },
            };
            return (await axios.post(
                `${Config.globalUrl}/api/v1/webapp/sadeAdmins/${SystemAdmin.profile.UserStorageID}/doctors/${HCP_UserStorageID}/profile`,
                hcp_data,
                requestconfig
            ));
            },
    getAllHCPs: async () => {
        if (!authenticationService.currentUserValue)
            return;
        let SystemAdmin = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/sadeAdmins/${SystemAdmin.profile.UserStorageID}/doctors/getAllHCP`,
            requestconfig
        );
        },

    AddNewAdmin: async (admin) => {
        if (!authenticationService.currentUserValue)
            return;
        let SystemAdmin = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return await axios.post(
            `${Config.globalUrl}/api/v1/webapp/sadeAdmins/${SystemAdmin.profile.UserStorageID}/admins/signup`,
            admin,
            requestconfig)
    },
    EditAdmin: async (admin_data,Admin_UserStorageID) => {

        if (!authenticationService.currentUserValue)
            return;
        let SystemAdmin = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return (await axios.post(
            `${Config.globalUrl}/api/v1/webapp/sadeAdmins/${SystemAdmin.profile.UserStorageID}/admins/${Admin_UserStorageID}/profile`,
            admin_data,
            requestconfig
        ));
        },
    deleteAdmin: async (Admin_UserStorageID) => {
        if (!authenticationService.currentUserValue)
            return;
        let SystemAdmin = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return (await axios.delete(
            `${Config.globalUrl}/api/v1/webapp/sadeAdmins/${SystemAdmin.profile.UserStorageID}/admins/${Admin_UserStorageID}/profile`,
            requestconfig
        ));
        },
    getAllAdmins: async () => {
        if (!authenticationService.currentUserValue)
            return;
        let SystemAdmin = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/sadeAdmins/${SystemAdmin.profile.UserStorageID}/admins/getAllAdmins`,
            requestconfig
        );
        },
    AddNewVersion: async (version) => {
        if (!authenticationService.currentUserValue)
            return;
        let SystemAdmin = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return (await axios.post(
            `${Config.globalUrl}/api/v1/webapp/sadeAdmins/${SystemAdmin.profile.UserStorageID}/versions/addNewVersion`,
            version,
            requestconfig
        ));
        },
    editVersion: async (version_data) => {
        if (!authenticationService.currentUserValue)
            return;
        let SystemAdmin = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return (await axios.post(
            `${Config.globalUrl}/api/v1/webapp/sadeAdmins/${SystemAdmin.profile.UserStorageID}/versions/editVersion`,
            version_data,
            requestconfig
        ));
        },
    getAllVersions: async () => {
        if (!authenticationService.currentUserValue)
            return;
        let SystemAdmin = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return await axios.get(
            `${Config.globalUrl}/api/v1/webapp/sadeAdmins/${SystemAdmin.profile.UserStorageID}/versions/getAllVersions`,
            requestconfig
        );
        },
    deleteVersion: async (VersionID) => {
        if (!authenticationService.currentUserValue)
            return;
        let SystemAdmin = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return (await axios.delete(
            `${Config.globalUrl}/api/v1/webapp/sadeAdmins/${SystemAdmin.profile.UserStorageID}/versions/${VersionID}`,
            requestconfig
        ));
        },
    sendMessageToPatients: async (data) => {
        if (!authenticationService.currentUserValue)
            return;
        let SystemAdmin = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return (await axios.post(
            `${Config.globalUrl}/api/v1/webapp/sadeAdmins/${SystemAdmin.profile.UserStorageID}/patients/sendMessages`,
            data,
            requestconfig
        ));
        },
    sendMessageToHcp: async (data) => {
        if (!authenticationService.currentUserValue)
            return;
        let SystemAdmin = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return (await axios.post(
            `${Config.globalUrl}/api/v1/webapp/sadeAdmins/${SystemAdmin.profile.UserStorageID}/doctors/sendMessages`,
            data,
            requestconfig
        ));
        },
    deleteClinic: async (Clinic_ID) => {
        if (!authenticationService.currentUserValue)
            return;
        let SystemAdmin = authenticationService.currentUserValue;
        let requestconfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authenticationService.currentUserValue.token,
            },
        };
        return (await axios.delete(
            `${Config.globalUrl}/api/v1/webapp/sadeAdmins/${SystemAdmin.profile.UserStorageID}/clinics/${Clinic_ID}`,
            requestconfig
        ));
        },

}

    export default adminApi;
